export function getErrorMessage(error) {
    return error?.response?.status == 403 ? "Security Problem: Access Denied" : error?.response?.data?.en ??
        `Something went wrong${error.message ? ', ' + error.message : '.'}`;
}